import React from 'react';
import { DiagnosticsPane } from 'mini-diagnostics-common';
import { FeedbackForm } from 'mini-feedback';
import { isDevToolsEnabled } from 'mini-diagnostics/lib/utils/isDevToolsEnabled';
import { LazyAddAccountPane } from 'mini-add-account';
import { LazyManageAccountsPane } from 'multi-account';
import { LazyRewardsModule } from 'mini-rewards-module-view';
import { OptionsPage } from 'mini-options-view';
import { ReportErrorForm } from 'mini-report-error';
import { type RewardsEntrypoint } from 'mini-rewards-module-view/lib/schema/RewardsEntrypoint';
import { Route } from 'mini-react-router-dom';
import { shouldShowFeedbackForm } from 'mini-sidepane/lib/utils/shouldShowFeedbackForm';
import {
    appendCatchAll,
    type ManageAccountsRoutes,
    type MiscRoutes,
    type SettingsRoutes,
    type RewardsRoutes,
} from 'mini-routes';
import type { MiniWorkLoad } from 'mini-workload';

export const getCommonRoutesForModule = (module: MiniWorkLoad): JSX.Element[] =>
    [
        <Route path={appendCatchAll('/settings')} element={<OptionsPage />} />,
        <Route
            path={appendCatchAll('/rewards')}
            element={<LazyRewardsModule entryPoint={'settings'} />}
        />,
        <Route path={appendCatchAll('/add-account')} element={<LazyAddAccountPane />} />,
        <Route path={appendCatchAll('/manage-accounts')} element={<LazyManageAccountsPane />} />,
        shouldShowFeedbackForm() && (
            <>
                <Route path={'/feedback'} element={<FeedbackForm source={module} />} />
                <Route
                    path={appendCatchAll('/report-error')}
                    element={<ReportErrorForm source={module} />}
                />
            </>
        ),
        isDevToolsEnabled() && <Route path={'/diagnostics'} element={<DiagnosticsPane />} />,
    ].filter(Boolean);
